import { z } from 'zod';
import { PixelEventBaseSchema } from '../pixel-event.mjs';

var _EventType = /* @__PURE__ */ ((_EventType2) => {
  _EventType2["LISTING_REDIRECT"] = "listing-redirect";
  return _EventType2;
})(_EventType || {});
var TrackingEvent;
((TrackingEvent2) => {
  TrackingEvent2.EventType = _EventType;
  const BaseSchema = PixelEventBaseSchema.extend({
    url: z.string()
  });
  TrackingEvent2.ListingRedirectEventSchema = BaseSchema.extend({
    type: z.literal("listing-redirect" /* LISTING_REDIRECT */),
    listingId: z.string(),
    source: z.string().nullable(),
    isListingUrl: z.boolean().optional(),
    announcementId: z.string().optional(),
    attributionId: z.string().optional()
  });
  TrackingEvent2.Validators = {
    ["listing-redirect" /* LISTING_REDIRECT */]: TrackingEvent2.ListingRedirectEventSchema
  };
})(TrackingEvent || (TrackingEvent = {}));

export { TrackingEvent, _EventType };
